<template>
  <SlideIn
    :open="isOpen"
    heading="Your Shopping Cart Is Full"
    @close="isOpen = false"
  >
    <template #content>
      <p>{{ message }}</p>
    </template>
  </SlideIn>
</template>

<script>
import SlideIn from "@/components/SlideIn.vue";

export default {
  name: "BagFailure",
  components: {
    SlideIn,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  emits: ["update:open", "editVariant"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(value) {
        return this.$emit("update:open", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
}
</style>
